<template>
    <v-dialog v-model="dialogVisible" max-width="500px" >

        <v-card>
            <v-card-title>
                <span class="text-h5">{{title}}</span>
            </v-card-title>
            <v-container>
                <slot name="content" :value="ctx"></slot>

            </v-container>
            <v-container v-if="verificationString">

                <p> Enter '{{ verificationString }}'' to confirm</p>
                <br/>
                <v-text-field ref="verifyInput" v-model="verifyComp"  label=""></v-text-field>
            </v-container>
            <v-container>
                    
                    <div class=" d-flex justify-end">
                        <v-btn v-if="verificationString" color="primary" @click="confirm"  :disabled="verificationString != verifyComp">Confirm</v-btn>
                        <v-btn v-else color="primary" @click="confirm">Confirm</v-btn>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <v-btn color="red" @click="cancel">Cancel</v-btn>
                    </div>

            </v-container>

        </v-card>
    </v-dialog>
</template>
<style ></style>
<script>
import { ref } from 'vue'
export default {
    props: {
        title: String,
        verificationString: String,
        ctx: Object,
    },
    setup(props, { emit }) {

        const dialogVisible = ref(false);
        const verifyComp = ref('');
        const verifyInput = ref(null);

        function cancel() {
            emit('cancel');
            verifyComp.value = '';
            close();
        }

        function confirm(){
            emit('confirm');
            verifyComp.value = '';
            close();
        }

        function open(){
            dialogVisible.value = true;

        }

        function close(){
            verifyComp.value = '';
            dialogVisible.value = false;
        }

        return {
            dialogVisible,
            confirm,
            cancel,
            open,
            close,
            verifyComp,
            verifyInput
        };
    },
    components: {},
    emits: ['confirm', 'cancel']
}
</script>
